import React, { useState, useEffect } from "react";
import { PrimaryButton } from "@fluentui/react";
import styles from "./ComparisonFAB.module.css";

interface ComparisonFABProps {
    selectedCount: number;
    onCompare: () => void;
    onClear: () => void;
}

export const ComparisonFAB: React.FC<ComparisonFABProps> = ({ selectedCount, onCompare, onClear }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);

    // Show modal when selection changes
    useEffect(() => {
        if (selectedCount > 0) {
            setIsModalVisible(true);
        } else {
            setIsModalVisible(false);
        }
    }, [selectedCount]);

    const handleDismiss = () => {
        setIsModalVisible(false);
    };

    const handleClear = () => {
        setIsModalVisible(false);
        onClear();
    };

    const handleCompare = () => {
        setIsModalVisible(false);
        onCompare();
    };

    if (selectedCount === 0) return null;

    return (
        <>
            {/* Desktop Modal */}
            <div className={`${styles.desktopModal} ${isModalVisible ? styles.visible : ""}`}>
                <div className={styles.modalBackdrop} onClick={handleDismiss}></div>
                <div className={styles.modalContent}>
                    <button
                        className={styles.closeButton}
                        onClick={handleDismiss}
                        aria-label="Cerrar"
                        title="Cerrar (puedes seguir seleccionando)"
                    >
                        ×
                    </button>

                    <div className={styles.iconContainer}>
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" className={styles.compareIcon}>
                            <rect x="3" y="3" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                            <rect x="13" y="3" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                            <rect x="3" y="13" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                            <rect x="13" y="13" width="8" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                        </svg>
                    </div>

                    <div className={styles.modalTitle}>Comparar Vehículos</div>

                    <div className={styles.selectionInfo}>
                        <div className={styles.countBadge}>{selectedCount}</div>
                        <div className={styles.countText}>
                            {selectedCount === 1 ? "vehículo seleccionado" : "vehículos seleccionados"}
                        </div>
                    </div>

                    <div className={styles.modalActions}>
                        <PrimaryButton
                            className={styles.compareButtonMain}
                            onClick={handleCompare}
                            disabled={selectedCount < 2}
                            text={selectedCount < 2 ? "Selecciona más vehículos" : "Comparar Ahora"}
                        />
                        <button
                            className={styles.cancelButton}
                            onClick={handleClear}
                        >
                            Limpiar Selección
                        </button>
                    </div>

                    <div className={styles.helpText}>
                        {selectedCount < 2
                            ? "Cierra este diálogo para seleccionar más vehículos"
                            : "O cierra para seguir seleccionando más"
                        }
                    </div>
                </div>
            </div>

            {/* Mobile FAB */}
            <div className={`${styles.mobileFAB} ${selectedCount > 0 ? styles.visible : ""}`}>
                <div className={styles.fabContent}>
                    <div className={styles.fabInfo}>
                        <span className={styles.fabCount}>{selectedCount}</span>
                        <span className={styles.fabText}>
                            {selectedCount === 1 ? "vehículo seleccionado" : "vehículos seleccionados"}
                        </span>
                    </div>
                    <div className={styles.fabActions}>
                        <button
                            className={styles.clearButton}
                            onClick={handleClear}
                            aria-label="Limpiar selección"
                        >
                            Limpiar
                        </button>
                        <PrimaryButton
                            className={styles.compareButton}
                            onClick={handleCompare}
                            disabled={selectedCount < 2}
                            text={selectedCount < 2 ? "Selecciona más" : "Comparar"}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
